import { Box, Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import Header from 'components/header'
import HeaderInfo from 'components/header-info'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { loadList } from 'services/requests'
import OrganizationHeader from '../view/organization-header'
import CardSkelleton from './card-skelleton'
import ProjectListFilter from './filter'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'projectName',
    label: 'Nome',
    width: 6,
    type: 'text',
  },
  {
    id: 'organizationName',
    label: 'Organização',
    width: 6,
    type: 'text',
  },
]

const ProjectList = () => {
  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])

  const [filter, setFilter] = useState<{ project: string; family: string }>({
    project: 'Todos',
    family: 'Todos',
  })

  const { state } = useLocation()
  const classes = useStyles()

  const organizationInfo = state || JSON.parse(localStorage.getItem('organizationInfo') || '{}')

  const list = useQuery({
    queryKey: [
      'projects',
      'view',
      'list',
      page,
      rowsPerPage,
      columnOrder,
      filter.family,
      filter.project,
      organizationInfo.organizationId,
    ],
    queryFn: () =>
      loadList('/projects/list', {
        search: '',
        page,
        rowsPerPage,
        columnOrder,
        organizationId: organizationInfo.organizationId,
      }),
    initialData: { data: { data: [] } } as any,
  })

  if (list.isError) {
    return <div>Error...</div>
  }

  const listData = list.data?.data.data as IProjectDTO[]

  const handleClearFilter = () =>
    setFilter({
      family: 'Todos',
      project: 'Todos',
    })

  return (
    <Wrapper>
      <Header>
        <HeaderInfo
          title='Automações'
          backRoute='/customers'
        />

        <ProjectListFilter
          filter={filter}
          onChangeFilter={setFilter}
          onClear={handleClearFilter}
        />
      </Header>

      <Page>
        <Box className={classes.container}>
          <Box className={classes.itemHead}>
            <OrganizationHeader
              corporateName={organizationInfo.organizationName}
              isInactive={false}
              logo={organizationInfo.logo}
            />
          </Box>

          <Grid
            container
            spacing={3}
            className={classes.itemList}
          >
            {list.isPending || list.isLoading || list.isFetching ? (
              <>
                <CardSkelleton />
                <CardSkelleton />
                <CardSkelleton />
                <CardSkelleton />
              </>
            ) : (
              <>
                {/* {listData.map((project) => (
                  <Grid
                    key={project?.id}
                    item
                    xs={6}
                  >
                    <ProjectListCard project={project as IProjectDTO}  organizationId={organizationInfo.id}/>
                  </Grid>
                ))} */}
              </>
            )}
          </Grid>
        </Box>
      </Page>
    </Wrapper>
  )
}
{
  /* <Table.Root>
          <Table.Overlay
            isEmpty={listData.length <= 0}
            isSearch={false}
            isLoading={list.isPending}
            route='/projects/new'
            emptyRouteText='Adicionar Projeto'
            searchRouteText='Adicionar Projeto'
            searchMessage='Nenhum Projeto encontrado, você pode criar um novo Projeto clicando no botão'
            emptyMessage='Seja bem-vindo à página de gerenciamento de Projeto. Até o momento, você não tem nenhum Projeto.'
          >
            <Table.Wrapper
              totalRows={rowsCount}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              page={page}
              handleClose={handleClose}
              handleCloseDelete={handleCloseDelete}
              modalIsOpen={modalIsOpen}
            >
              <Table.Header
                handleSortChange={handleSortChange}
                setOrder={setColumnOrder}
                headCells={headCells}
                order={columnOrder}
              />
              <Table.Body
                detailRoutePath='projects'
                headCells={headCells}
                rows={listData}
              />
            </Table.Wrapper>
          </Table.Overlay>
        </Table.Root> */
}

export default ProjectList
